export class InvalidCredentialsError extends Error {
  constructor(message: string = 'An unknown error occurred while performing client request') {
    super(message);
  }
}
